export const ActionsTopMembers = {
	GET_TOP_MEMBERS: "get_top_members",
	LOAD_GET_TOP_MEMBERS: "load_get_top_members",
	RES_GET_TOP_MEMBERS: "res_get_top_members",
	ERR_GET_TOP_MEMBERS: "err_get_top_members",
	HYDRATE: "HYDRATE",
};

export function failureTopMembers(err) {

	return {
		type: ActionsTopMembers.ERR_GET_TOP_MEMBERS,
		err,
	};

}

export function loadTopMembers(params = {}) {

	return {
		type: ActionsTopMembers.GET_TOP_MEMBERS,
		...params,
	};

}

export function loadGetTopMembers(params = {}) {

	return {
		type: ActionsTopMembers.LOAD_GET_TOP_MEMBERS,
		...params,
	};

}

export function loadTopMembersSuccess(data) {

	return {
		type: ActionsTopMembers.RES_GET_TOP_MEMBERS,
		data,
	};

}
